import Vue from 'vue';
import Vuetify, { VDataTable } from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify, {
  components: {
    VDataTable,
  },
});

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#ad932f',
        secondary: '#6c757d',
        error: '#f1556c',
      },
    },
  },
});
